import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CounselTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-counsel-type',
  templateUrl: './counsel-type.component.html',
  styleUrls: ['./counsel-type.component.scss'],
})
export class CounselTypeComponent implements OnChanges {
  counseltypeForm: FormGroup;
  counseltypeFormArray: FormGroup;
  control = new FormControl();
  @Input() counseltypes: CounselTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() counseltype = new EventEmitter<CounselTypeDto[]>();
  @Output() deleteCounselTypeEvent = new EventEmitter<any>();

  selectedCounselType: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createCounselTypeForm();
  }

  createCounselTypeForm() {
    this.counseltypeForm = this.fb.group({
      CounselTypeName: ['', Validators.required],
      id: null,
    });
    this.counseltypeFormArray = this.fb.group({
      CounselTypes: this.fb.array([]),
    });
    this.setCounselType();
  }

  // method to display counseltypes
  setCounselType() {
    const control = this.counseltypeFormArray.controls
      .CounselTypes as FormArray;
    this.counseltypes.forEach((e) => {
      control.push(
        this.fb.group({
          CounselTypeName: e.CounselTypeName,
          id: e.id,
        })
      );
    });
  }

  // method to add CounselType
  addCounselType(value: CounselTypeDto) {
    const control = this.counseltypeFormArray.controls
      .CounselTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        CounselTypeName: value.CounselTypeName,
        id: null,
      })
    );
  }

  selectCounselType(value) {}

  // method to delete counseltype from arrary list
  deleteCounselType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.counseltypeFormArray.controls
          .CounselTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.counseltypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.counseltypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: CounselTypeDto) {
    if (this.counseltypeForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.counseltypeFormArray
        .get('CounselTypes')
        ['controls'][this.selectedIndex].patchValue({
          CounselTypeName: formValue.CounselTypeName,
        });
    } else {
      this.addCounselType(formValue);
    }
    this.selectedIndex = null;
    this.counseltypeForm.reset();
  }

  onEdit(index, value: CounselTypeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.counseltypeForm.patchValue({ CounselTypeName: value.CounselTypeName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.counseltypeForm.reset();
  }

  onSubmit(formValue: CounselTypeDto[]) {
    this.counseltype.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteCounselTypeEvent.emit(this.filteredDelete);
    }
  }
}
